import { List, ShowButton, useTable } from '@refinedev/antd';
import { Table } from 'antd';
import { IExperienceEvent } from '../../../interfaces/experience';

export const ExperienceEventList = () => {
  const { tableProps } = useTable<IExperienceEvent>({
    sorters: {
      initial: [{ field: 'createdAt', order: 'desc' }],
    },
    meta: {
      fields: ['id', 'name', 'title', 'publishStatus'],
    },
  });

  return (
    <List headerProps={{ title: 'イベント一覧' }}>
      <Table
        {...tableProps}
        rowKey="id"
        pagination={{
          ...tableProps.pagination,
          showSizeChanger: true,
          showTotal: (total) => `全${total}件`,
        }}
      >
        <Table.Column dataIndex="name" title="名前" />
        <Table.Column dataIndex="title" title="タイトル" />
        <Table.Column dataIndex="publishStatus" title="ステータス" />
        <Table.Column<IExperienceEvent>
          dataIndex="actions"
          render={(_, record) => <ShowButton hideText size="small" recordItemId={record.id} />}
        />
      </Table>
    </List>
  );
};
